import { Component, OnInit, ViewChild } from "@angular/core";
import {
  MatTableDataSource,
  MatPaginator,
  MatDatepickerInputEvent,
  MatDialog,
  PageEvent,
} from "@angular/material";
import { AppService } from "src/_services/app.service";
import * as moment from "moment";
import { Router, ActivatedRoute, Params } from "@angular/router";
import { Location } from "@angular/common";
import { ConvertUpochToDate } from "src/_helpers/utils";
import { BetInfo } from "src/_models";
import { BetDetailsModalComponent } from "../bet-list/bet-list.component";

type PLMarket = {
  betCount: number;
  bets: Bet[];
  event_id: string;
  event_name: string;
  netAmount: number;
  provider_id: string;
};

type Bet = {
  betTime: number;
  betType: string;
  marketName: string;
  marketType: string;
  oddValue: number;
  runnerName: string;
  sessionOutCome: number;
  stakeAmount: number;
  status: string;
};

@Component({
  selector: "app-pl-market-statment",
  templateUrl: "./pl-market-stmt.component.html",
  styleUrls: ["./pl-event-statment.scss"],
})
export class PLMarketStatmentComponent implements OnInit {
  selected: any = { startDate: 0, endDate: 0 };
  eventLevelList = new MatTableDataSource<any>();
  betList = new MatTableDataSource<Bet>();

  ProviderId: string = "";
  plByMarketLevel: PLMarket;
  sportId: string;

  eventName: string;
  eventID: string;
  marketId: string;
  competitionId: any;
  OperatorId: any;
  endDate: any;
  startDate: any;

  eventLevelListDisplayedSportColumns: string[] = [
    "user_name",
    "bet_count",
    "profit_loss",
  ];
  userId: string;
  userName: string = "";
  page = 1;
  pageSize = 25;
  orgPageSize = 25;
  origin = [];
  category = "";
  subProvider = "";
  length: any = 0;
  pageEvent: any = { pageIndex: 1, pageSize: 0, length: 0 };

  constructor(
    private appService: AppService,
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private location: Location,
    public dialog: MatDialog
  ) {}

  ngOnInit() {
    this.sportId = this.activatedRoute.snapshot.params.sportId;
    this.eventID = this.activatedRoute.snapshot.params.eventId;
    this.marketId = this.activatedRoute.snapshot.params.marketId;
    this.competitionId = this.activatedRoute.snapshot.params.competitionId;

    this.activatedRoute.queryParams.subscribe((params) => {
      this.OperatorId = params.operatorId;
      this.ProviderId = params["providerId"];
      this.userId = params["userId"];
      this.userName = params["userName"];
      this.origin = params["origin"];
      this.category = params["category"];
      this.subProvider = params["subProvider"];
      this.selected = {
        startDate:
          params.startTime !== "0"
            ? new Date(params.startTime * 1000)
            : new Date(),
        endDate:
          params.endTime !== "0" ? new Date(params.endTime * 1000) : new Date(),
      };
    });

    this.getReportData();
    // this.getOurProviders();
  }
  @ViewChild(MatPaginator) paginator: MatPaginator;

  goBackToUserPL = () => {
    this.router.navigate([`reports/pl-statment/`]);
  };

  goBackToSportPL = () => {
    this.router.navigate([`reports/pl-statment/${this.sportId}`], {
      queryParams: {
        providerId: this.ProviderId,
        userId: this.userId ? this.userId : "",
        userName: this.userName ? this.userName : "",
        origin: this.origin ? this.origin : [],
        category: this.category ? this.category : "",
        subProvider : this.subProvider ? this.subProvider : "",
        operatorId: this.OperatorId !== "all" ? this.OperatorId : "",
        sportId: this.sportId,
        startTime:
            this.selected.startDate !== null
              ?  Math.floor(new Date(this.selected.startDate).getTime() / 1000)
              : 0,
          endTime:
            this.selected.endDate !== null
              ?  Math.floor(new Date(this.selected.endDate).getTime() / 1000)
              : 0,
      },
    });
  };

  goBackToCompetitionPL = () => {
    this.router.navigate(
      [`reports/pl-statment/${this.sportId}/${this.competitionId}`],
      {
        queryParams: {
          providerId: this.ProviderId,
          sportId: this.sportId,
          userId: this.userId ? this.userId : "",
          userName: this.userName ? this.userName : "",
          origin: this.origin ? this.origin : [],
          category: this.category ? this.category : "",
          subProvider : this.subProvider ? this.subProvider : "",
          operatorId: this.OperatorId !== "all" ? this.OperatorId : "",
          startTime:
            this.selected.startDate !== null
              ?  Math.floor(new Date(this.selected.startDate).getTime() / 1000)
              : 0,
          endTime:
            this.selected.endDate !== null
              ?  Math.floor(new Date(this.selected.endDate).getTime() / 1000)
              : 0,
        },
      }
    );
  };

  goBackToEventPL = () => {
    this.location.back();
  };

  onDateChangeHandler = (event: MatDatepickerInputEvent<Date>) => {
    this.selected = event;
    if (this.selected.startDate !== null) {
      this.getReportData();
    }
  };

  onSelectedProvider = (pid) => {
    this.ProviderId = pid;
    this.getReportData();
  };

  changePagination(event: PageEvent) {
    this.pageEvent = event;
    this.page = event.pageIndex + 1;
    this.pageSize = this.length;
    this.orgPageSize = event.pageSize;
    this.getReportData();
  }

  getReportData = () => {
    try {
      let filters = {
        sportId: this.sportId,
        providerId: this.ProviderId,
        operatorId: this.OperatorId,
        origin: this.origin ? this.origin : [],
        category: this.category ? this.category : "",
        subProvider : this.subProvider ? this.subProvider : "",
        startTime:
            this.selected.startDate !== null
              ?  Math.floor(new Date(this.selected.startDate).getTime() / 1000)
              : 0,
        endTime:
            this.selected.endDate !== null
              ?  Math.floor(new Date(this.selected.endDate).getTime() / 1000)
              : 0,
        userId: this.userId,
        marketId: this.marketId,
        competitionId: this.competitionId,
        eventId: this.eventID,
        pageSize: this.orgPageSize,
        page: this.page,
      };

      this.appService.geUserPLData(filters).subscribe((res) => {
        if (res.status === "RS_OK") {
          if (res.userReport && res.userReport.length > 0) {
            this.betList = new MatTableDataSource<any>(res.userReport);
            if (this.page == 1) {
              this.length = res.totalBets;
            } else {
              this.paginator.length = this.length;
            }
          }
        }
      });
    } catch (err) {}
  };

  formatDate(date) {
    return ConvertUpochToDate(date);
  }

  openDialog(betDetails: BetInfo) {
    this.dialog.open(BetDetailsModalComponent, {
      backdropClass: "backdropBackground",
      hasBackdrop: true,
      data: {
        betInfo: betDetails,
      },
    });
  }
}
